module.exports = "//public.zight.com/packs/media/images/onboarding/start-e383129280296f8c9506b3876bb87f91.svg";